import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { DATEPICKER_DATE_MASK_MATCHER, DATEPICKER_TIME_MASK_MATCHER } from '../constants';
export var getDatePartsFromString = function getDatePartsFromString(fullDate, enableTimePicker) {
  if (!fullDate) {
    return null;
  }
  var dateValue = fullDate.match(DATEPICKER_DATE_MASK_MATCHER) || [];
  var _dateValue = _slicedToArray(dateValue, 4),
    day = _dateValue[1],
    month = _dateValue[2],
    year = _dateValue[3];
  if (day && month && year) {
    var result = {
      day: Number(day),
      month: Number(month) - 1,
      year: Number(year)
    };
    result.formattedString = "".concat(result.day.toString().padStart(2, '0'), ".").concat((result.month + 1).toString().padStart(2, '0'), ".").concat(result.year);
    if (enableTimePicker) {
      var timeValue = fullDate.match(DATEPICKER_TIME_MASK_MATCHER) || [];
      var _timeValue = _slicedToArray(timeValue, 4),
        hour = _timeValue[1],
        minute = _timeValue[2],
        mode = _timeValue[3];
      if (hour && minute && mode) {
        result.hour = Number(hour);
        result.minute = Number(minute);
        result.mode = mode;
        result.formattedString = "".concat(result.formattedString, " ").concat(hour.toString().padStart(2, '0'), ":").concat(minute.toString().padStart(2, '0'), " ").concat(mode);
      }
    }
    return result;
  }
  return null;
};